import { useEffect, useState } from "react";

export const useTranslationModeSwitch = (): boolean => {
    const [mode, setMode] = useState(false);

    useEffect(() => {
        return;
        if (typeof document === "undefined") return; // SSR‑Guard

        const handler = (e: KeyboardEvent) => {
            const isMac = navigator.platform.toUpperCase().includes("MAC");
            const ctrlOrMeta = isMac ? e.metaKey : e.ctrlKey;

            if (ctrlOrMeta  && e.key === "ü") {
                e.preventDefault();
                setMode(prev => !prev);
            }
        };

        document.addEventListener("keydown", handler);
        return () => document.removeEventListener("keydown", handler);
    }, []);

    return mode;
};